export const LISTROLES = {
    superAdmin: 'super_admin',
    admin: 'admin',
    orgManager: 'org_manager',
    orgReporter: 'org_reporter',
    orgReader:  'org_reader',
    orgProcessor: 'org_processor',
    employerManager:  'company_manager',
    employerReporter:  'company_reporter',
    employerReader:  'company_reader',
}

export const LISTROLES_ARRAY = [
    {id: 1, name: 'Super Admin', value: 'super_admin'},
    {id: 2, name: 'Org Manager', value: 'org_manager'},
    {id: 3, name: 'Org Reporter', value: 'org_reporter'},
    {id: 4, name: 'Org Reader', value: 'org_reader'},
    {id: 5, name: 'Org Processor', value: 'org_processor'},
    {id: 6, name: 'Company Manager', value: 'company_manager'},
    {id: 7, name: 'Company Reporter', value: 'company_reporter'},
    {id: 8, name: 'Company Reader', value: 'company_reader'},
]